// gift-card-fathers-day-fields.js — native gift card form helpers (GCP removed).
// 1) Join recipient first + last into the reserved "Recipient name" property.
// 2) Drive the Send now / Send later toggle: empty "Send on" = send immediately (native behaviour),
//    a date = scheduled. The <gift-card-recipient> element (assets/theme.js) sets __shopify_offset
//    and the Send-on min/max; this only manages our show/hide + value.
(function () {
  // ---- first + last -> a single reserved property ----
  // recipient -> properties[Recipient name] (Shopify puts this on the gift card)
  // sender    -> properties[From]           (used by the New gift card notification)
  function combiner(group, outputId) {
    var out = document.getElementById(outputId);
    if (!out) return function () {};
    return function combine() {
      var parts = [];
      ["first", "last"].forEach(function (part) {
        var el = document.querySelector('[data-name="' + group + '"][data-part="' + part + '"]');
        if (el && el.value.trim()) parts.push(el.value.trim());
      });
      out.value = parts.join(" ");
      out.dispatchEvent(new Event("input", { bubbles: true })); // let the preview react
    };
  }

  var combiners = [
    combiner("recipient", "gcpRecipientNameValue"),
    combiner("sender", "gcpSenderNameValue"),
  ];

  ["recipient", "sender"].forEach(function (group, i) {
    ["first", "last"].forEach(function (part) {
      var el = document.querySelector('[data-name="' + group + '"][data-part="' + part + '"]');
      if (el) el.addEventListener("input", combiners[i]);
    });
    combiners[i]();
  });

  function combineName() {
    combiners.forEach(function (fn) { fn(); });
  }

  // ---- Send now / Send later ----
  var wrap = document.getElementById("gcpSendOnWrap");
  var sendOn = document.getElementById("gcpSendOnField");
  var later = document.getElementById("gcpSendLater");

  function applyWhen() {
    var isLater = !!(later && later.checked);
    if (wrap) wrap.toggleAttribute("hidden", !isLater);
    if (sendOn) {
      sendOn.required = isLater;
      if (!isLater) sendOn.value = ""; // empty Send on = deliver immediately
    }
  }

  document.querySelectorAll('input[name="gcp_when"]').forEach(function (r) {
    r.addEventListener("change", applyWhen);
  });
  applyWhen();

  // ---- Custom amount ----------------------------------------------------------
  // Two controls, one answer: the amount select is the single thing that submits
  // (name="id"). Typing a custom amount rewrites the hidden "Custom" option's value to a
  // variant on the denominations product and selects it. Nothing else is submitted, so
  // there is no second field to fall out of sync.
  //
  // Timing matters: the select flips to Custom on the FIRST keystroke so the two can never
  // show different numbers, but the amount is only rounded on blur — rounding while typing
  // would turn "4" into $20 under the user's fingers.
  (function customAmount() {
    var amountSel = document.getElementById("gcpAmount");
    var customOpt = document.getElementById("gcpAmountCustom");
    var input = document.getElementById("gcpCustomAmount");
    var ladderEl = document.getElementById("gcpAmountLadder");
    if (!amountSel || !customOpt || !input || !ladderEl) return;

    var ladder;
    try {
      ladder = JSON.parse(ladderEl.textContent);
    } catch (e) {
      return; // malformed data: leave the plain dropdown working
    }
    if (!ladder.length) return;

    var min = Number(input.dataset.min) || 0;
    var max = Number(input.dataset.max) || Infinity;
    var step = Number(input.dataset.step) || 10;
    var defaultValue = amountSel.value;

    // The field shows "$440". Digits are the only thing we keep, so a "$" the buyer types
    // themselves is absorbed rather than doubled up.
    function digitsOf(value) {
      return String(value).replace(/[^\d]/g, "");
    }

    function show(amount) {
      input.value = amount === "" ? "" : "$" + amount;
    }

    // Amounts already offered as named tiers — typing one of these should select that
    // tier rather than an identical-looking "Custom" entry.
    var tiers = {};
    Array.prototype.forEach.call(amountSel.options, function (o) {
      if (o.dataset.amount) tiers[Number(o.dataset.amount)] = o;
    });

    function nearest(amount) {
      return ladder.reduce(function (best, v) {
        return Math.abs(v.amount - amount) < Math.abs(best.amount - amount) ? v : best;
      }, ladder[0]);
    }

    function clearCustom() {
      customOpt.hidden = true;
      customOpt.value = "";
      input.value = "";
    }

    // First keystroke: show Custom immediately so the select never contradicts the field.
    input.addEventListener("input", function () {
      var digits = digitsOf(input.value);
      show(digits);                       // re-prefix on every keystroke: 40 -> $40
      if (digits === "") return;
      customOpt.hidden = false;
      customOpt.textContent = "Custom";   // same label at every stage: the select must not resize
      customOpt.selected = true;
    });

    // Commit: round, snap the field to what will actually be charged, resolve the variant.
    function commit() {
      var raw = parseFloat(digitsOf(input.value));
      if (isNaN(raw)) {
        clearCustom();
        amountSel.value = defaultValue;
        amountSel.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      // Check the typed figure against the named tiers BEFORE rounding — the tiers are
      // odd amounts ($169/$189/$229), so rounding first would push $189 to $190 and miss it.
      if (tiers[raw]) {
        clearCustom();
        tiers[raw].selected = true;
        amountSel.dispatchEvent(new Event("change", { bubbles: true }));
        return;
      }

      var wanted = Math.min(Math.max(Math.round(raw / step) * step, min), max);
      var match = nearest(wanted);

      if (tiers[match.amount]) {
        clearCustom();
        tiers[match.amount].selected = true;
      } else {
        customOpt.hidden = false;
        customOpt.value = match.id;
        customOpt.dataset.price = match.price;
        customOpt.textContent = "Custom";   // amount lives in the field, not here
        customOpt.selected = true;
        show(match.amount);         // show the real number, never round silently
      }
      amountSel.dispatchEvent(new Event("change", { bubbles: true })); // refresh the preview
    }

    input.addEventListener("blur", commit);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); commit(); }
    });

    // Choosing a listed denomination abandons the custom amount.
    amountSel.addEventListener("change", function () {
      if (!customOpt.selected) clearCustom();
    });
  })();

  // ---- Safety: recombine on submit ----
  var form = document.querySelector(".gcp__form") || document.querySelector('form[action*="/cart/add"]');
  if (form) form.addEventListener("submit", combineName);
})();